import { useReducer } from 'react';

export interface State {
    page: number;
    pageSize: number;
}

export interface SetPageAction {
    type: 'SET_PAGE';
    page: number;
}
export interface SetPageSizeAction {
    type: 'SET_PAGE_SIZE';
    pageSize: number;
}

export type Action = SetPageAction | SetPageSizeAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'SET_PAGE':
            return { ...state, page: action.page };

        case 'SET_PAGE_SIZE':
            // Reset to page 1 when page size changes
            return { ...state, page: 1, pageSize: action.pageSize };

        default:
            return state;
    }
};

const initialState: State = {
    page: 1,
    pageSize: 12,
};

const useListReducer = () => useReducer(reducer, initialState);

export default useListReducer;
